import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import EvidencijeObrazac10Dodavanje from "./EvidencijeObrazac10Dodavanje";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

const cellStyle = {
  padding: "8px 4px",
  textAlign: "center",
  verticalAlign: "middle",
  wordWrap: "break-word",
  border: "1px solid black",
};

function EvidencijeObrazac10() {
  const [data, setData] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);

  const { selectedMainEntity, baseUrl } = useGlobalContext();

  const fetchData = async () => {
    try {
      const { data: res } = await axios.post(
        `${baseUrl}/evidencija10/read.php`,
        { company_id: selectedMainEntity.company_id },
      );
      if (res.status === 200) setData(res.data);
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  useEffect(() => {
    if (!selectedMainEntity?.company_id) return;
    fetchData();
  }, [selectedMainEntity]);

  const handlePrint = async () => {
    const el = document.getElementById("print-obrazac10");
    if (!el) return;
    const useSignature = window.confirm(
      "Da li želite da dodate stranicu sa potpisom?",
    );
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div id="sig-page" style="width:287mm;height:200mm;margin:0 auto;position:relative;overflow:hidden;background:#fff;"><img id="signature-img" src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);display:block;"/></div></div>`;
    }
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blokiran.");
      return;
    }
    printWindow.document.write(
      `<html><head><meta charset="utf-8"/><style>@page{size:A4 landscape;margin:5mm 5mm 15mm 5mm;}body{margin:0;padding:5mm;font-family:sans-serif;font-size:14px;}table{width:100%;border-collapse:collapse;table-layout:fixed;}td{border:1px solid black;padding:2px;font-size:14px;vertical-align:middle;word-wrap:break-word;}hr{width:80%;margin:0 auto;margin-bottom:5px;border:0;border-top:1px solid #000;}</style></head><body>${el.innerHTML}${signatureHtml}</body></html>`,
    );
    printWindow.document.close();
    printWindow.onload = () => {
      const doPrint = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
      const img = printWindow.document.getElementById("signature-img");
      const box = printWindow.document.getElementById("sig-page");
      if (box) {
        const divs = Array.from(printWindow.document.querySelectorAll("div"));
        const footer = divs.find(
          (d) =>
            d.textContent?.includes("Саветник/сарадник") &&
            d.textContent?.includes("Послодавац"),
        );
        if (footer) footer.remove();
      }
      if (!img || !box) return doPrint();
      const fitAndPrint = () => {
        const nW = img.naturalWidth || 1;
        const nH = img.naturalHeight || 1;
        img.style.transform = `translate(-50%, -50%) rotate(${nW > nH ? -90 : 0}deg)`;
        doPrint();
      };
      if (img.complete && img.naturalWidth) fitAndPrint();
      else {
        img.onload = fitAndPrint;
        img.onerror = doPrint;
      }
    };
  };

  const { loggedUser, apiKey } = useGlobalContext();
  const [header, setHeader] = useState({ name: "", address: "", pib: "" });
  useEffect(() => {
    const fetchHeader = async () => {
      const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
      if (!id || !loggedUser?.id) return;
      try {
        const { data: res } = await axios.post(`${baseUrl}/companies/readCompanyDetails.php`, {
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: id,
        });
        if (res.status === 200) setHeader({
          name: res.data.company_name,
          address: res.data.company_address,
          pib: res.data.pib
        });
      } catch (e) { console.error(e); }
    };
    fetchHeader();
  }, [selectedMainEntity, loggedUser?.id]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        backgroundColor: "rgb(204,204,204)",
      }}
    >
      <div
        id="print-obrazac10"
        style={{
          overflowY: "auto",
          fontSize: "12px",
          padding: "40px",
          width: "100%",
          backgroundColor: "white",
          border: "1.5px solid #9f9f9f",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          <div>Образац 10</div>
          <div>ЕВИДЕНЦИЈА О ИЗВРШЕНИМ ИСПИТИВАЊИМА УСЛОВА РАДНЕ СРЕДИНЕ</div>
        </div>
        <br />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ width: "32%", textAlign: "center" }}>
            {selectedMainEntity.company_name}
            <hr
              style={{
                border: "0",
                borderTop: "1px solid black",
                marginBottom: "3px",
              }}
            />
            Пословно ime послодавца
          </div>
          <div style={{ width: "32%", textAlign: "center" }}>
            {header.address}
            <hr
              style={{
                border: "0",
                borderTop: "1px solid black",
                marginBottom: "3px",
              }}
            />
            Адреса седишта послодавца
          </div>
          <div style={{ width: "32%", textAlign: "center" }}>
            {header.pib}
            <hr
              style={{
                border: "0",
                borderTop: "1px solid black",
                marginBottom: "3px",
              }}
            />
            ПИБ послодавца
          </div>
        </div>
        <br />

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
            fontSize: "12px !important",
          }}
        >
          <thead>
            <tr>
              <td style={{ ...cellStyle, width: "60px", fontSize: "12px !important" }}>Редни број</td>
              <td style={{ ...cellStyle }}>
                Предмет превентивних и периодичних испитивања
              </td>
              <td style={{ ...cellStyle, width: "120px" }}>
                Број мерних места
              </td>
              <td style={{ ...cellStyle, width: "120px" }}>
                Број стручног налаза/извештаја
              </td>
              <td style={{ ...cellStyle, width: "120px" }}>Датум испитивања</td>
              <td style={{ ...cellStyle, width: "120px" }}>
                Датум следећег испитивања
              </td>
              <td style={{ ...cellStyle, width: "120px" }}>Напомена</td>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={item.id}>
                <td style={cellStyle}>{i + 1}.</td>
                <td
                  style={{
                    ...cellStyle,
                    textAlign: "left",
                    paddingLeft: "10px",
                  }}
                >
                  {item.predmet_ispitivanja}
                </td>
                <td style={cellStyle}>{item.broj_mernih_mesta}</td>
                <td style={cellStyle}>{item.broj_nalaza}</td>
                <td style={cellStyle}>{item.datum_ispitivanja}</td>
                <td style={cellStyle}>{item.datum_sledeceg}</td>
                <td
                  style={{
                    ...cellStyle,
                    textAlign: "left",
                    paddingLeft: "10px",
                  }}
                >
                  {item.napomena}
                </td>
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                {Array.from({ length: 7 }).map((_, i) => (
                  <td key={i} style={cellStyle}></td>
                ))}
              </tr>
            )}
          </tbody>
        </table>
        <br />

        <div
          style={{
            display: "flex",
            marginTop: "50px",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "45%", textAlign: "center" }}>
            <hr
              style={{
                border: "0",
                borderTop: "1px solid black",
                marginBottom: "5px",
              }}
            />
            Саветник/сарадник за безбедност и здравље на раду
          </div>
          <div style={{ width: "30%", textAlign: "center" }}>
            <hr
              style={{
                border: "0",
                borderTop: "1px solid black",
                marginBottom: "5px",
              }}
            />
            Послодавац
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        {isDodavanje ? (
          <EvidencijeObrazac10Dodavanje
            setIsDodavanje={setIsDodavanje}
            onRefresh={fetchData}
          />
        ) : (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div onClick={handlePrint}>
                <Button activation={true} style={styles.button}>
                  ШТАМПАЈ
                </Button>
              </div>
              <Button activation={true} style={styles.button}>
                ПОШАЉИ
              </Button>
            </div>
            <div onClick={() => setIsDodavanje(true)}>
              <Button activation={true} style={styles.button}>
                ДОДАЈ
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EvidencijeObrazac10;
